import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['submit'];

  connect() {
    this.validate();
  }

  validate() {
    const selects = this.element.querySelectorAll('select');
    const allSelectsFilled = Array.from(selects).every(select => select.value !== '');
    const isDisabled = !this.element.checkValidity() || !allSelectsFilled;
    // hCaptcha creates a sibling div with the same data-target attribute, use submitTargets to find all submit buttons
    const submitEl = this.submitTargets.find(t => t.matches('button, input[type="submit"]')) || this.submitTarget;
    submitEl.disabled = isDisabled;
  }
}
